<template>
    <footer class="bg-[#2F5085] text-white">
        <!-- Main Footer Content -->
        <div class="container mx-auto px-6 py-12">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

                <!-- School Info Section -->
                <div class="space-y-4">
                    <div class="flex justify-start">

                        <img :src="Logo" width="64" 
                        height="64"
                        class="h-16 md:h-12 w-auto"
                        alt="BPK PENABUR JAKARTA"
                        />
                        <div class="flex flex-col justify-center">
                            <p class="text-sm leading-none p-0 tracking-[0.17em]">Badan Pendidikan Kristen</p>
                            <p class="uppercase text-2xl  p-0">Penabur <span class=" font-normal">Jakarta</span></p>
                        </div>
                    </div>
                    <p class="text-blue-100 text-sm leading-relaxed text-justify">
                        Sekolah dengan pendidikan Kristen yang unggul dalam Iman, Ilmu,
                        Pelayanan dan membina karakter peserta didik melalui pengajaran
                        berdasarkan nilai kristian
                    </p>
                </div>

                <!-- Quick Links -->
                <div class="space-y-4">
                    <h4 class="font-semibold text-lg border-b border-blue-400 pb-2">Menu</h4>
                    <ul class="space-y-3">
                        <li>
                            <router-link to="/"
                                class="text-blue-100 hover:text-white relative group transition-all duration-300 ease-in-out text-sm block">
                                Home
                            </router-link>
                        </li>
                        <li>
                            <a href="https://bpkpenabur.or.id/" target="_blank" rel="noopener noreferrer"
                                class="text-blue-100 hover:text-white relative group transition-all duration-300 ease-in-out text-sm block">
                                Corporate Site
                            </a>
                        </li>
                        <li>
                            <router-link to="/school"
                                class="text-blue-100 hover:text-white relative group transition-all duration-300 ease-in-out text-sm block">
                                Schools
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/contact"
                                class="text-blue-100 hover:text-white relative group transition-all duration-300 ease-in-out text-sm block">
                                Contact Us
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/faq"
                                class="text-blue-100 hover:text-white relative group transition-all duration-300 ease-in-out text-sm block">
                                FAQ
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- Contact Info -->
                <div class="space-y-4">
                    <h4 class="font-semibold text-lg border-b border-blue-400 pb-2">Contact Us</h4>
                    <div class="space-y-3">
                        <div class="flex items-start space-x-3">
                            <MapPin class="w-5 h-5 text-blue-300 mt-0.5 flex-shrink-0" />
                            <p class="text-blue-100 text-sm">
                                BPK PENABUR JAKARTA
                                Jl. Tanjung Duren Raya No.4
                                Gedung Blok E lt.6
                                Jakarta Barat 11470
                            </p>
                        </div>
                        <div class="flex items-center space-x-3">
                            <Phone class="w-5 h-5 text-blue-300 flex-shrink-0" />
                            <a href="https://wa.me/6287820200031"
                                class="text-blue-100 hover:text-white transition-colors duration-200 text-sm">
                                +62 878-2020-0031
                            </a>
                        </div>
                        <div class="flex items-center space-x-3">
                            <Mail class="w-5 h-5 text-blue-300 flex-shrink-0" />
                            <a href="mailto:humas@bpkpenaburjakarta.or.id"
                                class="text-blue-100 hover:text-white transition-colors duration-200 text-sm">
                                humas@bpkpenaburjakarta.or.id
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Social Media -->
                <div class="space-y-4">
                    <h4 class="font-semibold text-lg border-b border-blue-400 pb-2">Follow Us</h4>
                    <p class="text-blue-100 text-sm mb-4">
                        Tetap terhubung dengan berita dan update terbaru dari BPK PENABUR Jakarta.
                    </p>
                    <div class="flex flex-wrap gap-3">
                        <a :href="facebookUrl" target="_blank" rel="noopener noreferrer"
                            class="w-10 h-10 bg-blue-600 hover:bg-blue-500 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="Facebook">
                            <Facebook class="w-5 h-5" />
                        </a>
                        <a :href="instagramUrl" target="_blank" rel="noopener noreferrer"
                            class="w-10 h-10 bg-pink-600 hover:bg-pink-500 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="Instagram">
                            <Instagram class="w-5 h-5" />
                        </a>
                        <a :href="youtubeUrl" target="_blank" rel="noopener noreferrer"
                            class="w-10 h-10 bg-red-600 hover:bg-red-500 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="YouTube">
                            <Youtube class="w-5 h-5" />
                        </a>
                        <a :href="tiktokUrl" target="_blank" rel="noopener noreferrer"
                            class="w-10 h-10 bg-black hover:bg-gray-800 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="TikTok">
                            <Music class="w-5 h-5" />
                        </a>
                        <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer"
                            class="w-10 h-10 bg-green-600 hover:bg-green-500 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="WhatsApp">
                            <MessageCircle class="w-5 h-5" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Footer -->
        <div class="border-t border-blue-400/30 bg-[#1e3a5f]">
            <div class="container mx-auto px-6 py-4">
                <div class="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
                    <div class="text-center md:text-left">
                        <p class="text-blue-100 text-sm">
                            Copyright &copy; BPK PENABUR JAKARTA {{ currentYear }}. All rights reserved.
                        </p>
                        <p class="text-blue-200 text-xs mt-1">
                            Developed by <span class="text-white font-medium">SIM</span>
                        </p>
                    </div>
                    <div class="flex space-x-6 text-sm">


                        <router-link to="/privacy-policy"
                            class="text-blue-100 hover:text-white transition-colors duration-200 capitalize">
                            privacy policy
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import Logo from '@/assets/icon.png';
import {
    Facebook,
    Instagram,
    Youtube,
    Music,
    MessageCircle,
    MapPin,
    Phone,
    Mail
} from 'lucide-vue-next'

// Props
const props = defineProps({
    whatsappNumber: {
        type: String,
        default: '6281234567890'
    },
    instagramUrl: {
        type: String,
        default: 'https://instagram.com/bpkpenaburjakarta'
    },
    youtubeUrl: {
        type: String,
        default: 'https://www.youtube.com/@BPKPENABURJkt'
    },
    tiktokUrl: {
        type: String,
        default: 'https://www.tiktok.com/@bpkpenaburjakarta'
    },
    facebookUrl: {
        type: String,
        default: 'https://www.facebook.com/bpkpenaburjkt/?locale=id_ID'
    }
})

// Reactive data
const email = ref('')

// Computed properties
const currentYear = computed(() => new Date().getFullYear())
const whatsappUrl = computed(() => `https://wa.me/${props.whatsappNumber}`)

// Methods
const subscribeNewsletter = () => {
    if (email.value) {
        // Handle newsletter subscription logic here
        alert(`Terima kasih! Email ${email.value} telah berhasil berlangganan newsletter.`)
        email.value = ''
    } else {
        alert('Silakan masukkan alamat email yang valid.')
    }
}
</script>

<style scoped>
.container {
    max-width: 1200px;
}

/* Custom scrollbar for better aesthetics */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #2F5085;
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: #1e3a5f;
}
</style>